import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import UserDetailsProvider from "./Context";

ReactDOM.render(
	<React.StrictMode>
		<UserDetailsProvider>
			<App />
		</UserDetailsProvider>
	</React.StrictMode>,
	document.getElementById("root")
);
